import React from 'react'
//import VehicleClass from '../models/VehicleClass.js';
import Progress from '../components/Progress.js';
import Upgrade from '../components/Upgrade.js';
import SCR from '../components/SCR.js';
import RezCentral from '../components/RezCentral.js';
import PersonalInfo from '../models/PersonalInfo.js';
import DatePicker from "react-datepicker";
import {Container, Row, Col, Button, Form, Spinner} from 'react-bootstrap/';

export default class Step4 extends React.Component {
  constructor(props){
      super(props);

      this.state = {
        loading : false,

        // form data
        dob : '',
        firstName : '',
        lastName : '',
        phone : '',
        email : '',
        confirmEmail : '',
        termsAndConditions : false,

        bill : {},
        errorMessage : '',
        errors : {},
        upgradeList : []//,
        //vehicleClass : new VehicleClass()
      }

      this.handleInputChange = this.handleInputChange.bind(this);
      this.placeReservation = this.placeReservation.bind(this);
      this.modifyDatesClick = this.modifyDatesClick.bind(this);
      this.changeVehicleClick = this.changeVehicleClick.bind(this);
      this.changeExtrasClick = this.changeExtrasClick.bind(this);
      //this.handleUpgradeClick = this.handleUpgradeClick.bind(this);
      this.getBill = this.getBill.bind(this);
  }

  componentDidUpdate(){
     SCR.resizeParent();
  }

  componentDidMount() {
    //console.log('step 4 props')
    //console.log(this.props.personalInfo.termsAndConditions)
    this.setState({
      dob : this.props.personalInfo.dob,
      firstName : this.props.personalInfo.firstName,
      lastName : this.props.personalInfo.lastName,
      phone : this.props.personalInfo.phone,
      email : this.props.personalInfo.email,
      termsAndConditions : typeof this.props.personalInfo.termsAndConditions !== 'undefined' ? this.props.personalInfo.termsAndConditions : false,
      vehicleClass : this.props.vehicleClass
    }, () => {
      this.getBill();
    });
  }

  getBill(){
    // get bill
    var billData = {
      pickupLocationId : this.props.pickup.locationId,
      dropoffLocationId : this.props.dropoff.locationId,
      pickupDateTime : this.getDateString(this.props.pickup.date,'') + ' ' + this.props.pickup.time,
      dropoffDateTime : this.getDateString(this.props.dropoff.date,'') + ' ' + this.props.dropoff.time,
      discountCode : this.props.discountCode,
      extras : this.props.extras,
      //confirmationNum : this.props.confirmationNum,

      // can update in step 4 upgrade class so need to use state for class
      classCode : this.props.vehicleClass.classCode,
      rateId : this.props.vehicleClass.rateId
    };

    //console.log('OPTIONS')
    //console.log(options)
    RezCentral.getBill(billData)
    .then((data) => {
      //console.log(data)
      if(data.data !== ""){
        //console.log(data)
        this.setState({ bill : data.data },
        () => {
          /*setTimeout(function(){
            SCR.resizeParent();
          }, 2000)*/


          // upgrade list
          if(!this.props.vehicleClass.isUpgrade)
            this.getUpgradeList(this.state.bill.totalCharges);
        });
      }
    });
  }

  getUpgradeList(totalCharges){
    //var self = this;
    var upgradeList = [];
    //var rentalList = [];

    var rateData = {
      pickupLocationId : this.props.pickup.locationId,
      dropoffLocationid : this.props.dropoff.locationId,
      pickupDateTime : this.getDateString(this.props.pickup.date,'') + ' ' + this.props.pickup.time,
      dropoffDateTime : this.getDateString(this.props.dropoff.date,'') + ' ' + this.props.dropoff.time,
      discountCode : this.props.discountCode,
      extras : this.props.extras
    };

    RezCentral.getRates(rateData)
    .then(data => {
      var rentalList = [];
      if(typeof data.data.rateProduct !== "undefined")
        rentalList = data.data.rateProduct;

      rentalList.forEach(rental => {
          //console.log(rental.totalPricing.totalCharges)
          if(parseFloat(rental.totalPricing.totalCharges) > totalCharges)
            upgradeList.push(
              {
                classCode : rental.classCode,
                classDesc : rental.classDesc,
                rateId : rental.rateID,
                modelDesc : rental.modelDesc,
                total : rental.totalPricing.totalCharges,
                img : rental.classImageURL.toLowerCase()
              });
      });
      if(upgradeList.length > 0)
        this.setState({ upgradeList : upgradeList});
    });
  }

  /*handleUpgradeClick(e){
    e.preventDefault();

    //var self = this;

    var arr = e.target.value.split('|');

    var vehicleClass = new VehicleClass();
    var rateId = arr[1];
    var vehClass = arr[0];
    var modelDesc = arr[2];
    var totalCharges = parseFloat(arr[3]);

    vehicleClass.setClass(vehClass);
    vehicleClass.setRateId(rateId);
    vehicleClass.setModelDesc(modelDesc);
    vehicleClass.setTotalCharges(totalCharges)
    vehicleClass.setIsUpgrade(true);

    // update vehicle class in state them update bill data
    this.setState(
      { vehicleClass : vehicleClass},
      () => { this.getBill(); }
    );

    this.props.setUpgradeClass(vehicleClass);
  }*/

  handleInputChange(event){
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  placeReservation(e){
    e.preventDefault();
    var self = this;

    if(this.validateFormInputs()){
      // show loading spinner
      this.setState({loading : true/*, errorMessage : ''*/});

      // call addRez
      var rezData = {
        pickupLocationId : this.props.pickup.locationId,
        dropoffLocationId : this.props.dropoff.locationId,
        pickupDateTime : this.getDateString(this.props.pickup.date, '') + ' ' + this.props.pickup.time,
        dropoffDateTime : this.getDateString(this.props.dropoff.date, '') + ' ' + this.props.dropoff.time,
        discountCode : this.props.discountCode,
        classCode : this.props.vehicleClass.classCode,
        rateId : this.props.vehicleClass.rateId,
        extras : this.props.extras,
        renterDob : this.getDateString(this.state.dob, '/'),
        renterFirst : this.state.firstName,
        renterLast : this.state.lastName,
        renterCellPhone : this.state.phone,
        emailAddress : this.state.email,
        termsAndConditions : 'Y'
      };

      // this is a rez mod so confirmation num was passed in
      if(this.props.confirmationNum !== '')
        rezData.confirmationNum = this.props.confirmationNum;

      RezCentral.addRez(rezData)
      .then((addRezRsp) => {
        if(addRezRsp.message === ''){

          // tracking
          var options = {};
          var page = '/thankyou';

          if(typeof addRezRsp.data.confirmNum !== 'undefined'){
            options.confirmationCode = addRezRsp.data.confirmNum;
            //page = page + '/' + addRezRsp.data.confirmNum;
          }

          window.history.replaceState(null, '', page);
          SCR.fireTracking(page, options);

          setTimeout(function(){
      				window.history.replaceState(null, '', '/reservation');
      			}, 2000);

          //var confirmationNum = addRezRsp.data.confirmNum;
            //console.log(confirmationNum)

          var info = new PersonalInfo();
          info.dob = this.state.dob;
          info.firstName = this.state.firstName;
          info.lastName = this.state.lastName;
          info.phone = this.state.phone;
          info.email = this.state.email;
          info.termsAndConditions = true;

          // call App to set data
          self.props.setPersonalInfo(info);

          this.setState({loading : false});

          // set confirmation details and transition page to confirmation
          self.props.setConfirmationDetails(addRezRsp.data);
        }else{
          //alert(addRezRsp.message)
          this.setState({errorMessage : addRezRsp.message, loading : false});
        }
      });
    }/*else {
      alert("Form has errors.<br/>" + this.state.errors);
    }*/
  }

  validateFormInputs(){
    //let fields = this.state.fields;
    var dob = this.state.dob;
    var firstName = this.state.firstName;
    var lastName = this.state.lastName;
    var phone = this.state.phone;
    var email = this.state.email;
    var confirmEmail = this.state.confirmEmail;
    var termsAndConditions = this.state.termsAndConditions;

    let errors = {};
    let formIsValid = true;

    if (!dob) {
      formIsValid = false;
      errors.dob = "Cannot be empty";
    }

    if (!firstName) {
      formIsValid = false;
      errors.firstName = "Cannot be empty";
    }

    if (!lastName) {
      formIsValid = false;
      errors.lastName = "Cannot be empty";
    }

    if (!phone) {
      formIsValid = false;
      errors.phone = "Cannot be empty";
    }else if(phone.length > 0){
      phone = phone.replace('-', '');
      if(phone.match(/\d/g).length!==10){
        formIsValid = false;
        errors.phone = "Phone not valid";
      }
    }

    if (!email) {
      formIsValid = false;
      errors.email = "Cannot be empty";
    }else if(email.length > 0){
      var re = /\S+@\S+\.\S+/;
      if(!re.test(email)){
        formIsValid = false;
        errors.email = "Email not valid";
      }
    }

    if (!confirmEmail || confirmEmail !== email) {
      formIsValid = false;
      errors.confirmEmail = "Cannot be empty";
    }

    if (!termsAndConditions) {
      formIsValid = false;
      errors.termsAndConditions = "Cannot be empty";
    }

    this.setState({ errors: errors });
    return formIsValid;
  }

  // handle button click
  modifyDatesClick(e){
    e.preventDefault();
    var self = this;
    //console.log('clicked');

    self.props.returnToStep(1);
  }

  // handle button click
  changeVehicleClick(e){
    e.preventDefault();
    var self = this;
    //console.log('clicked');
    //console.log(this.props)
    self.props.returnToStep(2);
  }

  // handle button click
  changeExtrasClick(e){
    e.preventDefault();
    var self = this;
    self.props.returnToStep(3);
  }

  getDateString(d, separator){
    if(d === '')
      return '';

    return ('0' + (d.getMonth()+1)).slice(-2) + separator + ('0' + d.getDate()).slice(-2) + separator + d.getFullYear();
  }

  render(){
    //console.log('Step 4 render called');
    // change button text if modifying reservation
    var placeReservationBtnTxt = 'Place Reservation';
    if(this.props.isModifyRez)
      placeReservationBtnTxt = 'Modify Reservation';

    var Vehicle = [];
    if(typeof this.state.bill.ratePeriod !== 'undefined'){ // && Object.keys(this.state.bill).length > 0){
      Vehicle =
      <Row>
        <Col><span>{this.state.bill.similarText}<br/>{this.state.bill.ratePeriod.rate1Days + ' DAY(s) @ ' + this.state.bill.ratePeriod.rate1PerDay + '/ Day'}</span></Col>
        <Col className="subtotal"><span>${this.state.bill.rateCharge}</span></Col>
      </Row>;
    }

      //Extras = <div>${this.state.bill.totalExtras}</div>
      //console.log(this.state.bill.dailyExtras.length)
      let Extras, Fees = [];

      if(typeof this.state.bill.dailyExtras !== 'undefined'){
        var extras = this.state.bill.dailyExtras || [];
        Extras = extras.map(
          (extra, index) => {
            //console.log(extra.extraCode)
            //if(selectedExtras.find(el => el === extra.extraCode)){
            if(extra.extraAutoApply === 'FALSE'){
              //console.log(extra.extraCode)
              return (<div className="row" key={extra.extraCode + '-' + index}>
                <div className="col"><span>{extra.extraDesc}</span></div>
                <div className="col subtotal"><span>${extra.extraAmount}</span></div>
              </div>);
            }else {
              return '';
            }
          });

        Fees = extras.map(
          (extra, index) => {
            //if(selectedExtras.find(el => el !== extra.extraCode)){
            if(extra.extraAutoApply === 'TRUE'){
              return (
                <div className="row" key={extra.extraCode + '-' + index}>
                  <div className="col"><span>{extra.extraDesc}</span></div>
                  <div className="col subtotal"><span>${extra.extraAmount}</span></div>
                </div>);
            }else {
              return '';
            }
          });

        // add surchage to fees
        Fees.push(<Row key={"surcharge"}>
              <Col><span>Surcharge</span></Col>
              <Col className="subtotal"><span>${this.state.bill.surcharge}</span></Col>
            </Row>);
      }

      let Discount = [];
      if(this.state.bill.rateDiscount){
        Discount =
        <>
        <Row className="mt-3">
          <Col><h5>Discounts</h5></Col>
          <Col></Col>
        </Row>
        <Row>
          <Col><span>Discount ({this.props.discountCode})</span></Col>
          <Col className="subtotal"><span>{this.state.bill.rateDiscount}</span></Col>
        </Row>
        </>
      }

      let Taxes = [];
      if(typeof this.state.bill.taxes !== 'undefined'){
        var taxes = this.state.bill.taxes;
        if(typeof taxes === 'object'){
          Taxes.push(<Row key={taxes.tax1Desc}>
                        <Col><span>{taxes.tax1Desc}&nbsp;
                        ({(taxes.tax1Rate * 100).toFixed(2)} %)</span></Col>
                        <Col className="subtotal"><span>${taxes.tax1Charge}</span></Col>
                      </Row>
                    );
          if(taxes.tax2Desc !== null && taxes.tax2Desc !== ''){
            //console.log("TAX 2 = "+taxes.tax2Desc)
            Taxes.push(
              <Row key={taxes.tax2Desc}>
                <Col><span>{taxes.tax2Desc}&nbsp;({(taxes.tax2Rate * 100).toFixed(2)} %)</span></Col>
                <Col className="subtotal"><span>${taxes.tax2Charge}</span></Col>
              </Row>
                      );
          }

        }else{ // if(typeof taxes === 'array'){
          Taxes = taxes.map(
            (tax, index) => {
              //console.log("TAX 2 = "+tax.tax2Desc)
              return(<Row key={index}>
                  <Col className="col"><span>{tax.tax1Desc} {tax.tax1Rate * 100}%</span></Col>
                  <Col className="col subtotal"><span>${tax.tax1Charge}</span></Col>
                </Row>
              );
            });
        }
    }

    let UnlimitedMileage = [];
//console.log('step 4 is upgrade = ' + this.props.vehicleClass.isUpgrade)
    let UpgradeOptions = [];
    if(this.props.confirmationNum === '' && this.state.upgradeList.length > 0 /*&& !this.props.vehicleClass.isUpgrade*/)
      UpgradeOptions = <Upgrade upgradeList={this.state.upgradeList} getBill={this.getBill} totalCharges={this.state.bill.totalCharges} setUpgradeClass={this.props.setUpgradeClass} />;


    return (
      <div>
        <Progress pickup={this.props.pickup} dropoff={this.props.dropoff} vehicleClass={this.props.vehicleClass} returnToStep={this.props.returnToStep} currentStep={this.props.currentStep} isModifyRez={this.props.isModifyRez} extras={this.props.extras} price={this.state.bill.totalCharges} personalInfo={this.props.personalInfo} />

        <Container fluid className="p-3 m-0">
          <Row className="">
            <Col><h3><b>Review</b></h3></Col>
          </Row>
          <Row xs={1} md={2}>
            <Col className="p-0">
                <Container fluid className="p-3 m-0 ">
                  <Row className="mb-3">
                    <Col><h2>Contact Details</h2></Col>
                  </Row>
                  <Row className="mb-3">
                      <Col>
                        <label className="form-label">Date of Birth:*</label>
                        <DatePicker
                          dateFormat="MM/dd/yyyy"
                          selected={this.state.dob}
                          onChange={(date) =>
                            this.setState({
                              dob: date
                            })
                          }
                          placeholderText=""
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          className={this.state.errors.dob ? 'error form-control' : 'form-control'}
                        />
                      </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col>
                      <label className="form-label">First Name:*:</label>
                      <Form.Control type="text" className={this.state.errors.firstName ? 'error' : ''} name="firstName" onChange={this.handleInputChange} value={this.state.firstName || ''} />
                    </Col>
                    <Col>
                      <label className="form-label">Last Name:*:</label>
                      <Form.Control type="text" className={this.state.errors.lastName ? 'error' : ''} name="lastName" onChange={this.handleInputChange} value={this.state.lastName  || ''} />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col>
                      <label className="form-label">Phone:*:</label>
                      <Form.Control type="text" className={this.state.errors.phone ? 'error' : ''} name="phone" onChange={this.handleInputChange} value={this.state.phone  || ''} />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                  <Col>
                    <label className="form-label">Email:*:</label>
                    <Form.Control type="text" className={this.state.errors.email ? 'error' : ''} name="email" onChange={this.handleInputChange} value={this.state.email  || ''} />
                  </Col>
                  </Row>
                  <Row className="mb-3">
                  <Col >
                    <label className="form-label">Confirm Email*:</label>
                    <Form.Control type="text" className={this.state.errors.confirmEmail ? 'error' : ''} name="confirmEmail" onChange={this.handleInputChange} value={this.state.confirmEmail} />
                  </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col className={this.state.errors.termsAndConditions ? 'error' : ''}>
                      {/**/}
                      <Row>
                        <Col xs={1} className="agree-terms"><Form.Check type="checkbox" name="termsAndConditions" checked={this.state.termsAndConditions} onChange={this.handleInputChange} /></Col>
                        <Col className="agree-terms-link"><a target="_blank" href="https://www.savannahcarrentals.com/privacy-policy/" rel="noreferrer">I agree to Terms and Conditions</a></Col>
                      </Row>
                      {/**/}
                   </Col>
                </Row>
              </Container>
          </Col> {/* end col */}
          {//<Col className="d-none d-md-block"></Col>
          }
          <Col id="review-details" className="p-0">
              <Container fluid className="p-3 mt-2 mt-md-0">
                <Row>
                  <Col><h2>Rental Details</h2></Col>
                </Row>
                <Row>
                  <Col><h5>Pickup Location</h5></Col>
                  <Col className="d-flex justify-content-end"><Button onClick={this.modifyDatesClick} className="rez-link">EDIT</Button></Col>
                </Row>
                <Row>
                  <Col>
                    <span className="location">{this.props.pickup.locationCity}<br/>
                    {SCR.prettyDate(this.props.pickup.date)} @ {this.props.pickup.time}</span>
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col><h5>Dropoff Location</h5></Col>
                </Row>
                <Row>
                  <Col>
                    <span className="location">{this.props.dropoff.locationCity}<br/>
                    {SCR.prettyDate(this.props.dropoff.date)} @ {this.props.dropoff.time}</span>
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col><h5>Vehicle</h5></Col>
                  <Col className="d-flex justify-content-end"><Button onClick={this.changeVehicleClick} className="rez-link">EDIT</Button></Col>
                </Row>
                {Vehicle}
                {UnlimitedMileage}

                <Row className="mt-3">
                  <Col><h5>Extras</h5></Col>
                  <Col className="d-flex justify-content-end"><Button onClick={this.changeExtrasClick} className="rez-link">EDIT</Button></Col>
                </Row>
                {Extras}
                <Row className="mt-3">
                  <Col>
                    <h5>Taxes & Fees</h5>
                  </Col>
                </Row>
                {Fees}
                {Taxes}

                {Discount}

                {UpgradeOptions}

                <Row className="mt-3">
                  <Col><h5>Estimated Total</h5></Col>
                  <Col id="total" className="d-md-flex justify-content-md-end">${this.state.bill.totalCharges}</Col>
                </Row>

                <Row className="mt-3">
                  <Col className="d-md-flex justify-content-md-end">
                    <Button onClick={this.placeReservation} disabled={this.state.loading ? true : false}>
                    {this.state.loading ?
                      <><Spinner animation="border" role="status"></Spinner> <span>Processing...</span></>  : placeReservationBtnTxt }
                    </Button>
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col className="d-md-flex justify-content-md-end text-danger">
                    {this.state.errorMessage}
                  </Col>
                </Row>
              </Container>

          </Col> {/* end col */}
        </Row> {/* end row */}
      </Container> {/* end container */}

    </div>
    );
  }
}
